import React from 'react';
import { notificationTitles } from './Messages';
import Input from 'components/Input';
import Collapsible from 'components/Collapsible';
import {
  AddNofiticationContainer,
  NotificationInputsContainer,
} from './styles';
import Select from '../../../../components/Select';
import { IOption } from '../../../../components/Select/Select';
import {
  IField,
  IFieldNotification,
  ITask,
  ITaskNotificationProperties,
} from 'store/tasks/tasksType';
import { Mention, MentionsInput } from 'react-mentions';
import Icon from '../../../../components/Icon/Icon';
import FieldNotification from './FieldNotification';
import { generateRandomString } from '../../../../utils/string';
import i18n, { languageDirection } from '../../../../i18n';
import { ICompany } from '../../../../store/companies/companiesTypes';

interface IComponentProps {
  onChangeInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
  notificationProperties: ITaskNotificationProperties;
  handleChangeSelectNotificationProperties: (
    key: string,
    value: string
  ) => void;
  template: ITask;
  onAddFieldNotification: (obj: IFieldNotification) => void;
  onRemoveFieldNotification: (ind: number) => void;
  onUpdateFieldNotification: (ind: number, obj: IFieldNotification) => void;
  questionFields: Array<IField>;
  company: ICompany;
}
const smsOptions = [
  {
    value: 'None',
    label: i18n.t('noMessage', { ns: 'companyManagement' }),
  },
  {
    value: 'ActionRequired',
    label: i18n.t('actionRequiredIfNeeded', { ns: 'companyManagement' }),
  },
] as IOption[];

export const notificationsPatternData = [
  {
    id: 'U',
    display: i18n.t('userApplyingChange', { ns: 'companyManagement' }),
  },
  { id: 'A', display: i18n.t('assignee', { ns: 'companyManagement' }) },
  { id: 'V', display: i18n.t('verifier', { ns: 'companyManagement' }) },
  { id: 'TP', display: i18n.t('publisher', { ns: 'companyManagement' }) },
  {
    id: 'STP',
    display: i18n.t('subtaskPublisher', { ns: 'companyManagement' }),
  },
  {
    id: 'AL',
    display: i18n.t('numberOfAssignees', { ns: 'companyManagement' }),
  },
  { id: 'TN', display: i18n.t('taskType', { ns: 'companyManagement' }) },
  { id: 'P', display: i18n.t('progressAmount', { ns: 'companyManagement' }) },
  { id: 'S', display: i18n.t('executionStatus', { ns: 'companyManagement' }) },
  {
    id: 'PD',
    display: i18n.t('progressExplanation', { ns: 'companyManagement' }),
  },
  {
    id: 'sd',
    display: i18n.t('startDateWithoutTime', { ns: 'companyManagement' }),
  },
  {
    id: 'sdh',
    display: i18n.t('startDateWithTime', { ns: 'companyManagement' }),
  },
  {
    id: 'dd',
    display: i18n.t('dueDateWithoutTime', { ns: 'companyManagement' }),
  },
  {
    id: 'ddh',
    display: i18n.t('dueDateWithTime', { ns: 'companyManagement' }),
  },
  {
    id: 'AT',
    display: i18n.t('assigneeTitle', { ns: 'companyManagement' }),
  },
  {
    id: 'VT',
    display: i18n.t('verifierTitle', { ns: 'companyManagement' }),
  },
];

const TemplateNotifications: React.FunctionComponent<IComponentProps> = ({
  onChangeInput,
  handleChangeSelectNotificationProperties,
  notificationProperties,
  template,
  company,
  onAddFieldNotification,
  onRemoveFieldNotification,
  onUpdateFieldNotification,
  questionFields,
}) => {
  const { alarmProgress, notifyWithSMS, notifyPastEvents } =
    notificationProperties;

  const notificationsPatternData = [
    {
      id: 'U',
      display: i18n.t('userApplyingChange', { ns: 'companyManagement' }),
    },
    { id: 'AT', display: i18n.t('assigneeTitle', { ns: 'companyManagement' }) },
    {
      id: 'AL',
      display: `${i18n.t('numberOf', { ns: 'companyManagement' })} ${template.assigneeTitle || i18n.t('assignee', { ns: 'companyManagement' })}`,
    },
    { id: 'VT', display: i18n.t('verifierTitle', { ns: 'companyManagement' }) },
    {
      id: 'A',
      display: `${template.assigneeTitle || i18n.t('assignee', { ns: 'companyManagement' })}`,
    },
    {
      id: 'V',
      display: `${template.verifierTitle || (i18n.t('verifier', { ns: 'companyManagement' }) as string)}`,
    },
    {
      id: 'TP',
      display: `${template.taskPublisherTitle || (i18n.t('publisher', { ns: 'companyManagement' }) as string)}`,
    },
    {
      id: 'STP',
      display: `${template.subTaskPublisherTitle || (i18n.t('subtaskPublisher', { ns: 'companyManagement' }) as string)}`,
    },
    { id: 'TN', display: i18n.t('taskType', { ns: 'companyManagement' }) },
    {
      id: 'P',
      display: i18n.t('progressAmount', { ns: 'companyManagement' }),
    },
    {
      id: 'S',
      display: i18n.t('executionStatus', { ns: 'companyManagement' }),
    },
    {
      id: 'PD',
      display: i18n.t('progressExplanation', { ns: 'companyManagement' }),
    },
    {
      id: 'sdh',
      display: `${template.startDateTitle || (i18n.t('startDate', { ns: 'companyManagement' }) as string)} ${i18n.t('withHour', { ns: 'companyManagement' })}`,
    },
    {
      id: 'sd',
      display: `${template.startDateTitle || (i18n.t('startDate', { ns: 'companyManagement' }) as string)} ${i18n.t('withoutHour', { ns: 'companyManagement' })}`,
    },
    {
      id: 'ddh',
      display: `${template.dueDateTitle || (i18n.t('dueDate', { ns: 'companyManagement' }) as string)} ${i18n.t('withHour', { ns: 'companyManagement' })}`,
    },
    {
      id: 'dd',
      display: `${template.dueDateTitle || (i18n.t('dueDate', { ns: 'companyManagement' }) as string)} ${i18n.t('withoutHour', { ns: 'companyManagement' })}`,
    },
    {
      id: 'PN',
      display: `${i18n.t('parentTaskName', { ns: 'companyManagement' }) as string}`,
    },
    {
      id: 'P2N',
      display: `${i18n.t('AncestorTaskName', { ns: 'companyManagement' }) as string}`,
    },
  ];

  template.fields.forEach((field) => {
    notificationsPatternData.push({
      id: `field:${field.name.replace(/\s+/, '_')}`,
      display: field.title || field.name,
    });
  });
  const displayTransform = (id: string) => {
    return (
      '(' +
      (notificationsPatternData.find((it) => it.id === id)?.display || id) +
      ')'
    );
  };
  return (
    <Collapsible
      header={
        i18n.t('notificationsSetting', { ns: 'companyManagement' }) as string
      }
      customCollapsibleHeaderStyle={{ zIndex: 150 }}
      style={{ overflow: 'visible' }}
    >
      <NotificationInputsContainer>
        {Object.keys({
          assignmentMessageAll: '',
          assignmentMessageSelf: '',
          verifierMessageSelf: '',
          unAssignmentMessageSelf: '',
          assignmentMessageProgressDoes: '',
          assignmentMessageProgressVerifier: '',
          assignmentMessageProgressDoesByOther: '',
          assignmentMessageProgressVerifierByOther: '',
          undraftAllSubTasksNotificationMessage: '',
          undraftAllSubTasksNotificationMessageToUsers: '',
          taskIsReadyToPublishNotificationMessage: '',
          subTasksAreReadyToPublishNotificationMessage: '',
        }).map((key) => {
          return (
            <div
              key={key}
              style={{
                maxHeight: '7rem',
                padding: '1rem 0',
                marginBottom: '1rem',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div className="flex flex-row items-center justify-between mx-2">
                <label>{notificationTitles[key]}</label>
                <Input
                  type="checkbox"
                  label={
                    i18n.t('disableSendingNotification', {
                      ns: 'companyManagement',
                    }) as string
                  }
                  checked={notificationProperties[key] === '-'}
                  id={key}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleChangeSelectNotificationProperties(key, '-');
                    } else handleChangeSelectNotificationProperties(key, '');
                  }}
                />
              </div>
              {notificationProperties[key] !== '-' && (
                <MentionsInput
                  value={notificationProperties[key] || undefined}
                  onChange={(e) => {
                    handleChangeSelectNotificationProperties(
                      key,
                      e.target.value
                    );
                  }}
                  forceSuggestionsAboveCursor={false}
                  allowSuggestionsAboveCursor={true}
                  allowSpaceInQuery={true}
                  className={`surveySMSPattern ${languageDirection() === 'rtl' ? 'rtl-mention' : 'ltr-mention'}`}
                  placeholder={notificationTitles[key]}
                  style={{ zIndex: 100 }}
                >
                  <Mention
                    trigger={'%'}
                    data={notificationsPatternData}
                    markup={'%__id__'}
                    displayTransform={displayTransform}
                    regex={/%(\S+)/}
                    appendSpaceOnAdd={true}
                  />
                  <Mention
                    trigger={'٪'}
                    data={notificationsPatternData}
                    markup={'%__id__'}
                    displayTransform={displayTransform}
                    regex={/%(\S+)/}
                    appendSpaceOnAdd={true}
                  />
                </MentionsInput>
              )}
            </div>
          );
        })}
        <div className="pt-3">
          <Input
            id="alarmProgress"
            type="checkbox"
            name="alarmProgress"
            label={
              i18n.t('alarmProgress', { ns: 'companyManagement' }) as string
            }
            checked={alarmProgress}
            onChange={onChangeInput}
          />
          <Input
            id="notifyPastEvents"
            type="checkbox"
            name="notifyPastEvents"
            label={
              i18n.t('notifyPastEvents', { ns: 'companyManagement' }) as string
            }
            checked={notifyPastEvents}
            onChange={onChangeInput}
          />
          <Select
            label={i18n.t('sendSMS', { ns: 'companyManagement' }) as string}
            options={smsOptions}
            values={[
              smsOptions.find((it) => it.value === notifyWithSMS) ||
                smsOptions[0],
            ]}
            allowRemove={false}
            multiChoice={false}
            onChangeValues={(values) => {
              handleChangeSelectNotificationProperties(
                'notifyWithSMS',
                values[0]?.value!.toString()
              );
            }}
          />
        </div>
        <AddNofiticationContainer
          onClick={() =>
            onAddFieldNotification({
              fieldName: '',
              values: [],
              targetUser: '',
              message: '',
              notifyWithSMS: true,
              notifyWhenDraft: false,
              key: generateRandomString(10),
            })
          }
        >
          <Icon
            type="plus-circle"
            style={{ fontSize: '1.5rem', cursor: 'pointer' }}
          />
          <div>
            {
              i18n.t('notifyUsersBaseOnSelectedQuestion', {
                ns: 'companyManagement',
              }) as string
            }
          </div>
        </AddNofiticationContainer>
        {template &&
          template?.notificationProperties?.fieldNotifications?.map(
            (item, index) => {
              return (
                <FieldNotification
                  key={item.key}
                  id={index}
                  item={item}
                  handleDeleteField={() => onRemoveFieldNotification(index)}
                  onUpdateFieldNotification={onUpdateFieldNotification}
                  questionFields={questionFields}
                  notificationsPatternData={notificationsPatternData}
                  company={company}
                />
              );
            }
          )}
      </NotificationInputsContainer>
    </Collapsible>
  );
};

export default TemplateNotifications;
